module.exports = __webpack_public_path__ + "static/hero-5433ceeb1ebb426ce9b13bc5bc98efc7.jpg";